const DAY_MS = 24 * 60 * 60 * 1000
/** Invitations stay valid for seven days; the expiry is not editable. */
export const INVITATION_LIFETIME_DAYS = 7
// The server accepts at most seven days measured on its own clock; the margin absorbs request
// latency and a client clock running slightly ahead.
const SERVER_CLOCK_MARGIN_MS = 10 * 60 * 1000

export const invitationExpiresAt = (now: number = Date.now()): string =>
  new Date(now + INVITATION_LIFETIME_DAYS * DAY_MS - SERVER_CLOCK_MARGIN_MS).toISOString()
